import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const userLogin = JSON.parse(localStorage.getItem("userData"));

  return userLogin ? children : <Navigate to="/auth/signin" replace />;
};

export default PrivateRoute;
